import React, { useState } from "react";
import Draggable from "react-draggable";

function PriceRangeSelector() {
  const [price, setPrice] = useState(50);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const newPosition = { x: position.x + ui.deltaX, y: 0 };
    setPosition(newPosition);

    const maxPosition = 200;
    const newPrice = Math.round((newPosition.x / maxPosition) * 100);
    setPrice(newPrice);
  };

  const handleStyle = {
    width: "20px",
    height: "20px",
    background: "#0074d9",
    borderRadius: "50%",
    cursor: "grab",
  };

  const lineStyle = {
    width: "100%",
    height: "5px",
    background: "#ccc",
    position: "relative",
  };

  const priceDisplayStyle = {
    marginTop: "20px",
    fontSize: "18px",
  };

  return (
    <div>
      <div style={lineStyle}>
        <Draggable
          axis="x"
          bounds={{ left: 0, right: 200 }}
          position={position}
          onDrag={handleDrag}
        >
          <div style={handleStyle}></div>
        </Draggable>
      </div>
      <div style={priceDisplayStyle}>
        <span>Price: ${price}</span>
      </div>
    </div>
  );
}

export default PriceRangeSelector;
